import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { validationMixin } from "vuelidate";
import { requiredIf } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FilogixDetailsForm",
  components: {
    MaterialInput
  },
  validations: {
    firmCode: {
      required: requiredIf(function () {
        return this.showFilogix && this.requireLenderSubmissionDetails;
      })
    },
    expertLoginId: {
      required: requiredIf(function () {
        return this.showFilogix && this.requireLenderSubmissionDetails;
      })
    }
  },
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    showFilogix: {
      type: Boolean,
      default: true
    },
    showEquifax: {
      type: Boolean,
      default: true
    },
    onlyShowProfileNumberField: {
      type: Boolean,
      default: false
    },
    requireLenderSubmissionDetails: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    licenseRegistrationNumberTooltip() {
      return this.$t("settings.accountTab.licenseRegistrationNumberTooltip");
    },
    expertProfileNumberTooltip() {
      return this.$t("settings.accountTab.expertProfileNumberTooltip");
    },
    userIdTooltip() {
      return this.$t("settings.accountTab.userIdTooltip");
    },
    subscriberNumberTooltip() {
      return this.$t("settings.accountTab.subscriberNumberTooltip");
    },
    subscriberSecurityCodeTooltip() {
      return this.$t("settings.accountTab.subscriberSecurityCodeTooltip");
    },
    subscriberPasswordTooltip() {
      return this.$t("settings.accountTab.subscriberPasswordTooltip");
    },
    firmCode: {
      get() {
        return this.value.firmCode;
      },
      set(firmCode) {
        this.emitValues("firmCode", firmCode);
      }
    },
    expertProfileNumber: {
      get() {
        return this.value.expertProfileNumber;
      },
      set(expertProfileNumber) {
        this.emitValues("expertProfileNumber", expertProfileNumber);
      }
    },
    userId: {
      get() {
        return this.value.userId;
      },
      set(userId) {
        this.emitValues("userId", userId);
      }
    },
    subscriberNumber: {
      get() {
        return this.value.subscriberNumber;
      },
      set(subscriberNumber) {
        this.emitValues("subscriberNumber", subscriberNumber);
      }
    },
    expertLoginId: {
      get() {
        return this.value.expertLoginId;
      },
      set(expertLoginId) {
        this.emitValues("expertLoginId", expertLoginId);
      }
    },
    subscriberSecurityCode: {
      get() {
        return this.value.subscriberSecurityCode;
      },
      set(subscriberSecurityCode) {
        this.emitValues("subscriberSecurityCode", subscriberSecurityCode);
      }
    },
    subscriberPassword: {
      get() {
        return this.value.subscriberPassword;
      },
      set(subscriberPassword) {
        this.emitValues("subscriberPassword", subscriberPassword);
      }
    },
    licenseRegistrationNumber: {
      get() {
        return this.value.licenseRegistrationNumber;
      },
      set(licenseRegistrationNumber) {
        this.emitValues("licenseRegistrationNumber", licenseRegistrationNumber);
      }
    }
  },
  methods: {
    emitValues(key, value) {
      this.$emit("input", _objectSpread(_objectSpread({}, this.value), {}, {
        [key]: value
      }));
    }
  }
});